import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppSelector } from '../../../hook/useAppSelector';
import { resetCashRegister } from '../../../store/slice/cash-register-slice';
import { fetchGeoFilters, resetGeoFilters } from '../../../store/slice/filter-slice';
import { resetGlobalFilters } from '../../../store/slice/global-filters';
import { CASH_REGISTER_URL } from '../../../util/url';
import DesktopHeader from './DesktopHeader';
import MobileHeader from './MobileHeader';
import { useAppDispatch } from '../../../hook/useAppDispatch';
import useDateAndTime from '../../../hook/useDateAndTime';

interface Props {
  title: string;
  icon: string;
}

const Header: React.FC<Props> = ({ title, icon }) => {
  const location = useLocation();
  const dispatch = useAppDispatch();

  const isMobile = useAppSelector((state) => state.configSlice.isMobile);
  const isCashRegister = location.pathname === CASH_REGISTER_URL;
  const { startDate } = useDateAndTime();

  const initialStartDateRef = useRef(startDate);

  const payload = {
    CompanyID: null,
    RegionID: null,
    GroupID: null,
    LocationID: null,
    DeviceID: null,
    GetAllAbove: false,
    GetAllBelow: false,
    GetUserLevel: true,
  };

  useEffect(() => {
    dispatch(resetGeoFilters());
    dispatch(resetGlobalFilters());

    if (!isCashRegister) {
      dispatch(resetCashRegister());
    }
  }, [location.pathname, dispatch, isCashRegister]);

  useEffect(() => {
    dispatch(
      fetchGeoFilters({
        ...payload,
        StartDate: initialStartDateRef.current,
      }),
    );
    // eslint-disable-next-line
  }, [dispatch]);

  return (
    <>
      {isMobile ? (
        <MobileHeader title={title}></MobileHeader>
      ) : (
        <DesktopHeader title={title} icon={icon}></DesktopHeader>
      )}
    </>
  );
};

export default Header;
